/**
 * Generic user utility functions for display purposes.
 * These have no domain-specific dependencies.
 */ /**
 * Generates initials from a name string
 */ export function getInitials(name) {
    if (!name) {
        return "??";
    }
    const parts = name.trim().split(/\s+/);
    if (parts.length >= 2) {
        return `${parts[0].charAt(0).toUpperCase()}${parts[parts.length - 1].charAt(0).toUpperCase()}`;
    }
    return name.length >= 2 ? `${name.charAt(0).toUpperCase()}${name.charAt(1).toUpperCase()}` : name.charAt(0).toUpperCase();
}
/**
 * Generates user initials from first and last name
 */ export function getUserInitials(firstName, lastName) {
    const fullName = [
        firstName,
        lastName
    ].filter(Boolean).join(" ");
    return getInitials(fullName);
}
/**
 * Formats a user's full name
 */ export function getUserFullName(firstName, lastName) {
    if (!firstName && !lastName) {
        return "Unknown User";
    }
    return [
        firstName,
        lastName
    ].filter(Boolean).join(" ");
}
/**
 * Origin the backend's ROOT-RELATIVE avatar URLs resolve against.
 *
 * The avatar route is served by the API, and the API now hands out
 * root-relative paths (`/api/v2/users/…/avatar/…`) rather than a public CDN
 * URL. Deployed, the SPA and the API share one origin behind Caddy, so the
 * relative path is already correct and this stays `""`. In local dev the two
 * run on different ports, so the SPA sets this to the API origin at startup —
 * the same `BACKEND_ENDPOINT` every API call already uses — via
 * {@link configureAvatarBaseUrl}. packages/ui cannot read the SPA's env, hence
 * the injection point rather than a direct import.
 */ let avatarBaseUrl = "";
/**
 * Set the origin that root-relative avatar URLs are resolved against. Called
 * once by the SPA at bootstrap; a trailing slash is normalized away.
 */ export function configureAvatarBaseUrl(baseUrl) {
    avatarBaseUrl = baseUrl.replace(/\/+$/, "");
}
/**
 * Gets the avatar URL for a user, preferring WebP format with JPEG fallback.
 *
 * A root-relative path from the backend is joined onto the configured base
 * origin; an already-absolute URL (a legacy CDN link) is returned untouched.
 */ export function getUserAvatarUrl(user, size = "medium") {
    if (!user?.avatar) {
        return undefined;
    }
    const url = user.avatar[size].webp || user.avatar[size].jpeg;
    if (!url) return url;
    if (/^https?:\/\//.test(url)) return url;
    // Strip leading slashes before joining: a plain concat would yield
    // `origin//api/v2/…`, and Express 5 does not collapse the empty segment.
    return avatarBaseUrl ? `${avatarBaseUrl}/${url.replace(/^\/+/, "")}` : url;
}

//# sourceMappingURL=user-utils.js.map